// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"783":"3bb87f23","806":"b1d422a5","9408":"cac3387d"}[chunkId] + ".chunk.css");